import styled from 'styled-components';

export interface IModal {
  top?: number | string,
  width?: number | string,
  height?: number | string
}

export const ModalOverlay = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: .5;
`;

export const ModalWrapper = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
`;

export const Modal = styled.div<IModal> `
  z-index: 100;
  background: white;
  position: relative;
  margin: 1.75rem auto;
  top: ${props => props.top}%;
  max-width: ${props => props.width}px;
  max-height: ${props => props.height}px;
  padding: 1rem 2rem;
`;

export const ModalHeader = styled.div `
  display: flex;
  justify-content: flex-start;

  h3 {
    margin: 0;
    font-size: 22px;
  }

  .modal-close-button {
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    opacity: .3;
    cursor: pointer;
    border: none;
  }
`;

export const ModalBody = styled.div `
  > p {
    color: #000;
  }
`;

export const ModalFooter = styled.div `
  text-align: right;

  > .btn-default {
    color: #005EB8;
    border-radius: 2px;
    font-weight: bold;
    font-size: 12px;
    background-color: transparent;
    border: none;
    line-height: 2;
    cursor: pointer;
    padding: 5px 10px;
    
    &:hover {
      background-color: #D8EAFC;
    }

    &:focus {
      outline: none;
      box-shadow: none;
    }

    &:not(:last-child) {
      margin-right: 2px;
    }
  }
`;